import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IPublicKey, Iterable } from "types";

type InitialState = {
  graphhopper: Iterable<IPublicKey>[];
};

const initialState: InitialState = {
  graphhopper: [],
};

const slice = createSlice({
  name: "publicKeys",
  initialState: initialState,
  reducers: {
    setGraphhopperKeys: (
      state,
      action: PayloadAction<Iterable<IPublicKey>[]>
    ) => {
      state.graphhopper = [...action.payload];
    },
  },
});

export const {
  reducer,
  actions: { setGraphhopperKeys },
} = slice;
